export const COLORS = {
  BLUE: '#1661c2',
  BLACK: 'black',
  WHITE: 'white',
  GREEN: '#00ce25',
  RED: '#e53935',
  MATCH_CONNECTOR: 'rgba(0, 206, 37, 0.8)',
  MISMATCH_CONNECTOR: 'rgba(229, 57, 53, 0.8)',
  /** Subtle tray behind the 3×3 tile grid (#ddcec5 page background). */
  GRID_BACKDROP: '#c4b4ac',
} as const;